import { Link } from 'react-router-dom';

export default function NotFoundPage(): JSX.Element {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="text-7xl font-extrabold text-brand-600">404</p>
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-slate-600 dark:text-slate-400">The page you’re looking for doesn’t exist.</p>
      <Link to="/" className="btn-primary mt-2">Back home</Link>
    </div>
  );
}
